/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_CompletedInputs */



/**
* | output |
* | --- |
* | "Spell check process completed successfully" |
*
* @param {Spellcheck_CompletedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_completed = /** @type {((inputs?: Spellcheck_CompletedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_CompletedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verification orthographique terminee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtschreibprüfung erfolgreich abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Processo di controllo ortografico completato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Процесс проверки орфографии успешно завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El proceso de revisión ortográfica se completó correctamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("拼写检查过程已成功完成。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スペルチェックプロセスが正常に完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तनी जाँच प्रक्रिया सफलतापूर्वक पूरी हो गई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A verificação ortográfica foi concluída com sucesso.")
	return /** @type {LocalizedString} */ ("Spell check process completed successfully")
});